import { render, staticRenderFns } from "./MfInfo.vue?vue&type=template&id=d0b6e9b8&scoped=true&"
import script from "./MfInfo.vue?vue&type=script&lang=js&"
export * from "./MfInfo.vue?vue&type=script&lang=js&"
import style0 from "./MfInfo.vue?vue&type=style&index=0&id=d0b6e9b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b6e9b8",
  null
  
)

export default component.exports